import React, { useState } from "react";
import { handleProspects } from "../../services/merchant";
import toast from "react-hot-toast";
import Spinner from "../../components/Spinner";

const UpdateProspectModal = ({ prospect, setOpenModal, onSuccess, userEmail }) => {
  const [comment, setComment] = useState("");
  const [decision, setDecision] = useState("APPROVED");
  const [approvalLevel, setApprovalLevel] = useState(prospect.approvalLevel || 1);
  const [merchantId, setMerchantId] = useState("");
  const [terminalId, setTerminalId] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        approvedBy: userEmail,
        approved: decision !== "DECLINED",
        approvalLevel: parseInt(approvalLevel),
        onboardingId: prospect.onboardingId,
        businessType: prospect.businessType,
        merchantId: merchantId,
        terminalId: terminalId,
        decision: decision,
      };

      if (decision !== "APPROVED") {
        payload.comment = comment;
      }

      const res = await handleProspects(payload);
      toast.success(res.message || "Prospect updated successfully");
      setOpenModal(false);
      if (onSuccess) onSuccess();
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An error occurred");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 overflow-auto bg-black bg-opacity-50 flex justify-center items-center">
      <div className="modal-content flex flex-col justify-center h-fit w-[450px] bg-white p-6 rounded shadow-lg relative">
        <button
          className="close absolute top-3 right-2 py-1 cursor-pointer px-4 text-orange-400 border border-orange-400 rounded-md"
          onClick={() => setOpenModal(false)}
        >
          x
        </button>
        <h2 className="text-xl font-bold mb-4 text-navy-blue">Update Merchant</h2>
        <p className="text-sm mb-4">Updating: <b>{prospect.name}</b></p>

        <form onSubmit={handleSubmit}>
          <div className="flex flex-col mt-4">
            <label htmlFor="decision" className="text-sm font-medium mb-1 font-bold">Decision</label>
            <select
              id="decision"
              value={decision}
              onChange={(e) => setDecision(e.target.value)}
              className="focus:outline-none focus:ring-2 focus:ring-orange-200 w-full h-[45px] border rounded-md px-3 bg-form-background"
            >
              <option value="APPROVED">APPROVED</option>
              <option value="HOPE_ACCOUNT_REQUIRED">HOPE ACCOUNT REQUIRED</option>
              <option value="DECLINED">DECLINED</option>
            </select>
          </div>

          <div className="flex flex-col mt-4">
            <label htmlFor="merchantId" className="text-sm font-medium mb-1 font-bold">Merchant ID</label>
            <input
              id="merchantId"
              type="text"
              value={merchantId}
              onChange={(e) => setMerchantId(e.target.value)}
              className="focus:outline-none focus:ring-2 focus:ring-orange-200 w-full h-[45px] border rounded-md px-3 bg-form-background"
              placeholder="Enter Merchant ID"
              required
            />
          </div>

          <div className="flex flex-col mt-4">
            <label htmlFor="terminalId" className="text-sm font-medium mb-1 font-bold">Terminal ID</label>
            <input
              id="terminalId"
              type="text"
              value={terminalId}
              onChange={(e) => setTerminalId(e.target.value)}
              className="focus:outline-none focus:ring-2 focus:ring-orange-200 w-full h-[45px] border rounded-md px-3 bg-form-background"
              placeholder="Enter Terminal ID"
              required
            />
          </div>

          <div className="flex flex-col mt-4">
            <label htmlFor="approvalLevel" className="text-sm font-medium mb-1 font-bold">Approval Level</label>
            <select
              disabled
              id="approvalLevel"
              value={approvalLevel}
              onChange={(e) => setApprovalLevel(e.target.value)}
              className="focus:outline-none focus:ring-2 focus:ring-orange-200 w-full h-[45px] border rounded-md px-3 bg-form-background"
            >
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
            </select>
          </div>

          {decision !== "APPROVED" && (
            <div className="flex flex-col mt-4">
              <label htmlFor="comment" className="text-sm font-medium mb-1 font-bold">Comment</label>
              <textarea
                id="comment"
                rows="4"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                className="focus:outline-none focus:ring-2 focus:ring-orange-200 w-full border rounded-md p-3 bg-form-background"
                placeholder="Enter your comment here..."
                required
              ></textarea>
            </div>
          )}

          <div className="mt-6">
            <button
              disabled={loading}
              className={`w-full h-[50px] rounded-md text-white font-medium transition-all duration-300 ${loading ? "bg-primary opacity-70 cursor-not-allowed" : "bg-primary hover:bg-opacity-90"
                }`}
              type="submit"
            >
              {loading ? <Spinner /> : "Submit Update"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateProspectModal;
